import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.idle-session-modal-title { color: ${dt('idleSessionModal.title.color')}; }
.idle-session-modal-text { color: ${dt('idleSessionModal.text.color')}; }
`;
